import React from "react";

import { format } from "date-fns";
import { t } from "i18next";

export interface ITaskDateRangeProps {
	start: string | Date;
	end?: string | Date | null;
}

export const TaskDateRange: React.FC<ITaskDateRangeProps> = ({
	start,
	end,
}) => {
	const startDate = format(new Date(start), t("dates.dateFormat"));
	const endDate = end ? format(new Date(end), t("dates.dateFormat")) : null;
	return (
		<>
			{!!end
				? t(
						startDate === endDate
							? "dates.theAtFromToHours"
							: "dates.theAtFromToDates",
						{
							dateFrom: startDate,
							dateTo: format(end, t("dates.dateFormat")),
							date: startDate,
							from: format(start, t("dates.timeFormat")),
							to: format(end, t("dates.timeFormat")),
						}
					)
				: t("dates.theAt", {
						date: startDate,
						time: format(start, t("dates.timeFormat")),
					})}
		</>
	);
};
